import createSnackbar from "../Utils/snackbar"
import instance from "../Utils/instance"

export const getPermissionsTypeAction = body => {
  const REQUEST = instance({
    method: 'get',
    url: 'settings/permissions/types/get.php'
  })
  return {
    type: "GET_PERMISSION_TYPES",
    payload: REQUEST
  }
}

export const editPermissionsTypeAction = body => {
  const REQUEST = instance({
    method: 'post',
    url: 'settings/permissions/types/edit.php',
    data: body
  })
  createSnackbar(REQUEST)
  return {
    type: 'EDIT_PERMISSION_TYPE',
    payload: REQUEST
  }
}

export const createPermissionsTypeAction = body => {
  const REQUEST = instance({
    method: 'post',
    url: 'settings/permissions/types/create.php',
    data: body
  })
  createSnackbar(REQUEST)
  return {
    type: 'CREATE_PERMISSION_TYPE',
    payload: REQUEST
  }
}